import axios from 'axios'
import Vue from 'vue'
let axiosAccess = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    
    headers: {
        
        'Content-Type': 'application/json',
       
      },
  })

export async function fetchDatos (context,payload){
    try{
    let url = "access/bittroqueladoran1/_getdata"//la direccion de la api
    
   
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('limit',payload.limit)    
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
         
    context.commit('setDatos',response.data.data)
  
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}
export async function fetchAll (context){
    try{
    let url = "access/bittroqueladoran1/_getAll"//la direccion de la api
    
   
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
         
    context.commit('setDatos',response.data.data)
  
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}

export async function buscarPorCampo (context,payload){
    try{
    let url = "access/bittroqueladoran1/_buscar"//la direccion de la api
    
   
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('limit',payload.limit)  
    values.append('campo',payload.campo)
    values.append('valor',payload.valor)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
         
    context.commit('setDatos',response.data.data)
  
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}